import { Link, useNavigate } from "react-router-dom";

interface HotTagsProps {
  tags: string[];
}

export default function HotTags({ tags }: HotTagsProps) {
  const navigate = useNavigate();

  return (
    <aside
      aria-label="热门话题"
      className="rounded-lg border border-background-200 bg-background-50 p-5"
    >
      <div className="flex items-center gap-2">
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-price-tag-3-line" />
        </span>
        <h3 className="text-sm font-semibold text-foreground-950">热门话题</h3>
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        {tags.map((tag) => (
          <button
            key={tag}
            type="button"
            onClick={() => navigate(`/search?q=${encodeURIComponent(tag)}`)}
            className="rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
          >
            #{tag}
          </button>
        ))}
      </div>

      <div className="mt-6 rounded-lg bg-secondary-100/70 p-4">
        <h3 className="text-sm font-semibold text-secondary-900">订阅每日娱乐简报</h3>
        <p className="mt-1 text-xs leading-relaxed text-secondary-800/80">
          每天一封，只挑值得看的娱乐内容，不打扰。
        </p>
        <Link
          to="/about"
          className="mt-3 inline-flex items-center gap-1 rounded-md bg-secondary-600 px-3 py-2 text-xs font-semibold text-background-50 transition-colors hover:bg-secondary-700"
        >
          前往订阅读
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>
    </aside>
  );
}